import {type FileRecordType} from '@packages/systems/core/records/FileRecord';
import {type AssetsType} from '@packages/systems/designer/assets';
import {LocalizedSettingsUtils} from '@packages/systems/localization';
import {singleMemo} from '@packages/utilities/memo';
import {type CanvasAssetWithRenderProperties} from '../components';

const extractAssetData =
  (currentLocaleId: string | undefined) =>
  (asset: FileRecordType): CanvasAssetWithRenderProperties => ({
    cdnUrl: asset.cdnUrl,
    alt: currentLocaleId
      ? LocalizedSettingsUtils.getLocalizedField(asset, currentLocaleId, 'alt')
      : asset.alt,
    type: asset.type,
  });

/**
 * Builds a map of assets with only properties that the Canvas needs to render.
 */
export const buildCanvasAssetMap = singleMemo((assets: AssetsType) => {
  return singleMemo((currentLocaleId: string | undefined) => {
    return assets.map(extractAssetData(currentLocaleId)).toJS();
  });
});
